import { FC, useMemo } from 'react'
import styles from 'components/features/pfm/AccountActionsMenu/AccountActionsMenu.styl'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'
import { ActionMenu } from 'components/features/pfm/ActionMenu/ActionMenu'
import { ActionMenuItem } from 'components/features/pfm/ActionMenu/ActionMenuItem'
import { AccountActionViewProviderSiteHandler } from 'components/features/pfm/AccountActionHandler/AccountActionViewProviderSiteHandler'
import { AccountActionUpdateHandler } from 'components/features/pfm/AccountActionHandler/AccountActionUpdateHandler'
import { AccountActionContinueHandler } from 'components/features/pfm/AccountActionHandler/AccountActionContinueHandler'
import { AccountActionCancelHandler } from 'components/features/pfm/AccountActionHandler/AccountActionCancelHandler'
import { AccountActionLinkHandler } from 'components/features/pfm/AccountActionHandler/AccountActionLinkHandler'
import { AccountActionUnlinkHandler } from 'components/features/pfm/AccountActionHandler/AccountActionUnlinkHandler'
import { AccountActionDeleteHandler } from 'components/features/pfm/AccountActionHandler/AccountActionDeleteHandler'
import { AccountActionCreateManualHandler } from 'components/features/pfm/AccountActionHandler/AccountActionCreateManualHandler'
import SvgIcon from 'components/atoms/SvgIcon'
import LeaveSvg from 'icons/leave.svg'
import ArrowSvg from 'icons/arrow.svg'
import EditSvg from 'icons/pencil.svg'
import CrossSvg from 'icons/cross.svg'
import TrashSvg from 'icons/trash.svg'
import LinkSvg from 'icons/link.svg'
import UnlinkSvg from 'icons/unlink.svg'

type AccountActionsMenuProps = {
  accountInfo: MixedAccountsTableItem
  onHide: () => void
}

export const AccountActionsMenu: FC<AccountActionsMenuProps> = (props) => {
  const { accountInfo, onHide } = props

  const itemsChild = useMemo(() => (
    <>
      <AccountActionViewProviderSiteHandler accountInfo={ accountInfo }>
        <ActionMenuItem icon={ <SvgIcon src={ LeaveSvg } /> }>
          Visit Provider Website
        </ActionMenuItem>
      </AccountActionViewProviderSiteHandler>

      <AccountActionContinueHandler accountInfo={ accountInfo }>
        <ActionMenuItem icon={ <SvgIcon src={ ArrowSvg } /> }>
          Continue
        </ActionMenuItem>
      </AccountActionContinueHandler>

      <AccountActionUpdateHandler accountInfo={ accountInfo } kind='retry'>
        <ActionMenuItem icon={ <SvgIcon src={ EditSvg } /> }>
          Retry
        </ActionMenuItem>
      </AccountActionUpdateHandler>

      <AccountActionUpdateHandler accountInfo={ accountInfo } kind='update_credentials'>
        <ActionMenuItem icon={ <SvgIcon src={ EditSvg } /> }>
          Update Credentials
        </ActionMenuItem>
      </AccountActionUpdateHandler>

      <AccountActionCancelHandler accountInfo={ accountInfo }>
        <ActionMenuItem icon={ <SvgIcon src={ CrossSvg } /> }>
          Cancel
        </ActionMenuItem>
      </AccountActionCancelHandler>

      <AccountActionUpdateHandler accountInfo={ accountInfo } kind='update_manual_account'>
        <ActionMenuItem icon={ <SvgIcon src={ EditSvg } /> }>
          Update
        </ActionMenuItem>
      </AccountActionUpdateHandler>

      <AccountActionCreateManualHandler accountInfo={ accountInfo }>
        <ActionMenuItem icon={ <SvgIcon src={ EditSvg } /> }>
          Link your account manually
        </ActionMenuItem>
      </AccountActionCreateManualHandler>

      <AccountActionLinkHandler accountInfo={ accountInfo }>
        <ActionMenuItem icon={ <SvgIcon src={ LinkSvg } /> }>
          Link
        </ActionMenuItem>
      </AccountActionLinkHandler>

      <AccountActionUnlinkHandler accountInfo={ accountInfo }>
        <ActionMenuItem icon={ <SvgIcon src={ UnlinkSvg } /> }>
          Unlink
        </ActionMenuItem>
      </AccountActionUnlinkHandler>

      <AccountActionDeleteHandler accountInfo={ accountInfo }>
        <ActionMenuItem icon={ <SvgIcon src={ TrashSvg } /> }>
          Delete
        </ActionMenuItem>
      </AccountActionDeleteHandler>

    </>
  ), [accountInfo])

  return (
    <ActionMenu onHide={ onHide } className={ styles.accountActionsMenu }>
      { itemsChild }
    </ActionMenu>
  )
}
